import { useState, useEffect } from "react";

const usePageFocus = () => {
  const [isFocusPage, setIsFocusPage] = useState(true);

  useEffect(() => {
    const handleFocus = () => setIsFocusPage(true);
    const handleBlur = () => setIsFocusPage(false);
    window.addEventListener("focus", handleFocus);
    window.addEventListener("blur", handleBlur);
    return () => {
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("blur", handleBlur);
    };
  }, []);

  return isFocusPage;
};

export default usePageFocus;
